export const sendSmsMessage = ({
  phoneNumber,
  message,
}: {
  phoneNumber?: string;
  message?: string;
}) => {
  const body = message ? `?&body=${encodeURIComponent(message)}` : '';
  const smsLink = `sms:${phoneNumber ?? ''}${body}`;

  window.open(smsLink, '_blank');
};
